import { signInAnonymously } from "firebase/auth";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import LoadingPlaceholder from "../../components/common/LoadingPlaceholder/LoadingPlaceholder";
import { BriaAxios } from "../../config/axios.tsx";
import { firebaseAuth } from "../../config/firebase.ts";
import { useAppStore } from "../../hooks/useStores";
import styles from "./PublicLayout.module.scss";

const PublicLayout = () => {
	const { authStore, anonymousUsageStore } = useAppStore();
	const [anonymousAuthReady, setAnonymousAuthReady] = useState(false);

	useEffect(() => {
		const ensureAuth = async () => {
			if (firebaseAuth.currentUser) {
				setAnonymousAuthReady(true);
				return;
			}

			try {
				await signInAnonymously(firebaseAuth);
			} catch (error) {
				console.error("Failed to sign in anonymously:", error);
			}
			setAnonymousAuthReady(true);
		};

		if (authStore.isInitialized) {
			if (firebaseAuth.currentUser) {
				setAnonymousAuthReady(true);
			} else {
				ensureAuth();
			}
		}
	}, [authStore.isInitialized]);

	useEffect(() => {
		const fetchAnonymousUsage = async () => {
			if (!anonymousAuthReady || authStore.isLoggedIn) return;

			try {
				const axios = await BriaAxios();
				const response = await axios.get("/anonymous_usage");
				const { features } = response.data;
				anonymousUsageStore.setBulkUsage(features);
			} catch (error) {
				console.error("Failed to fetch anonymous usage:", error);
			}
		};

		fetchAnonymousUsage();
	}, [anonymousAuthReady, authStore.isLoggedIn, anonymousUsageStore]);

	const isReady = anonymousAuthReady || authStore.isLoggedIn;

	return (
		<LoadingPlaceholder className={styles.loaderStyle} isLoading={!isReady}>
			<Outlet />
		</LoadingPlaceholder>
	);
};

export default observer(PublicLayout);
